/**
 * Created by rathompson on 6/10/22
 * File: TableFilter
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { Button, Input, Tooltip } from '@panwds/react-ui'
import { RemoveIcon, SearchIcon } from '@panwds/icons'

export const TableFilter = ({
  onChange,
  placeholder = 'Search...',
  value,
  onClear,
  tooltipLabel = 'Search for specific data within the table'
}) => {
  return (
    <Tooltip label={tooltipLabel}>
      <div className='cm-w-full'>
        <Input
          aria-label="Table filter"
          placeholder={placeholder}
          onChange={onChange}
          prefix={<SearchIcon size='sm' className='cm-text-gray-300' />}
          suffix={
            <Button
              aria-label='clear'
              appearance='tertiary-clear'
              onClick={onClear}
              size='sm'
              icon={<RemoveIcon size='sm' className='cm-text-gray-300' />}
              addClassName={value ? '' : 'cm-hidden'}
            />
          }
          value={value}
        />
      </div>
    </Tooltip>
  )
}

TableFilter.propTypes = {}
export default TableFilter
